<template>
    <RouterLink
        class="border inline-flex flex-row items-center rounded-md group focus-visible:outline-offset-1 focus-visible:outline-2"
        :to="props.target"
        target="_blank"
        :class="{
            'border-gray-300 focus-visible:outline-gray-700 hover:border-gray-800':
                props.variant === 'No-Stored-Scenario',
            'border-sky-700 focus-visible:outline-sky-700 hover:border-sky-800 active:border-sky-900':
                props.variant === 'Stored-Scenario',
        }"
    >
        <span
            class="leading-[1.2] self-stretch rounded-l-[0.3125rem] flex items-center text-center px-2 text-sm w-min"
            :class="{
                'bg-sky-100 text-gray-700 group-hover:bg-sky-700 group-hover:text-sky-50 group-active:bg-sky-900 group-active:text-sky-50':
                    props.variant === 'Stored-Scenario',
                'bg-gray-50 text-gray-700 group-active:bg-gray-300': props.variant === 'No-Stored-Scenario',
            }"
        >
            <span v-if="props.variant === 'No-Stored-Scenario'">{{ $t('no-scenario-stored') }}</span>
            <span v-else>{{ $t('scenario-stored') }}</span>
        </span>

        <span
            class="p-[0.5625rem] rounded-r-[0.3125rem]"
            :class="{
                'bg-sky-700 text-sky-50 group-hover:bg-sky-800 group-active:bg-sky-900':
                    props.variant === 'Stored-Scenario',
                'bg-gray-200 text-gray-700 group-active:bg-gray-300': props.variant === 'No-Stored-Scenario',
            }"
        >
            <TacticIcon class="size-5.5" />
        </span>
    </RouterLink>
</template>

<script setup lang="ts">
import { RouteLocationRaw, RouterLink } from 'vue-router';
import TacticIcon from '../Icon/TacticIcon.vue';

type ScenarioLinkButtonProps = {
    target: RouteLocationRaw;
    variant: 'No-Stored-Scenario' | 'Stored-Scenario';
};

const props = defineProps<ScenarioLinkButtonProps>();
</script>
